import React, { useRef, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Video from "shared/media/videos/backgroundVideo.mp4";
import Sound from "shared/media/backgroundSound.mp3";
import IconButton from "@mui/material/IconButton";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import MusicOffIcon from "@mui/icons-material/MusicOff";
import "react-toastify/dist/ReactToastify.css";
import "./Layout.scss";

const Layout = () => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayPause = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <div className="landingMain">
      <video autoPlay muted loop poster="path to video">
        <source src={Video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <audio ref={audioRef} src={Sound} />
      <IconButton className="soundToggleButton" onClick={handlePlayPause}>
        {isPlaying ? <MusicNoteIcon /> : <MusicOffIcon />}
      </IconButton>

      <div className="d-flex landingMainCenter justify-content-center align-items-center h-100">
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;
